import React, {useEffect, useState} from 'react';
import {Modal} from 'antd';
import {getName, removeUnderScoreWithLowerCase} from '../../../../utility/utility';
import {Leave_Type} from "../../../../constant/constant";
import dayjs from "dayjs";
import {CalendarOutlined, ClockCircleOutlined, MessageOutlined, ScheduleOutlined,} from "@ant-design/icons";
import {Button} from "antd/lib";
import TextArea from "antd/lib/input/TextArea";
import server from "../../../../server";
import Locale from "../../../../core/locale/locale";
import EmployeeAvatar from "../../../../page-components/employee/avatar/employee-avatar";
import '../../../../styles/component/leave-review-modal.scss';

interface ILeaveReviewModalProps {
    data: any,
    pageNumber: number,
    supervisor: {
        empId: string;
        isSupervisor: boolean;
    };
    isOpen: boolean,
    handleModalClose: () => void,
    isAdmin: boolean,
    fetchLeaveRequests: (pageNumber: number, field: any, direction: any) => void,
    field?: any,
    direction?: any
}

interface ILeaveBalanceData {
    employeeName: string;
    leaveType: string;
    applied: number;
    balance: number;
    alotted: number
}

const LeaveReviewModal: React.FC<ILeaveReviewModalProps> = ({
                                                                data,
                                                                isOpen,
                                                                handleModalClose,
                                                                isAdmin,
                                                                supervisor,
                                                                fetchLeaveRequests,
                                                                pageNumber,
                                                                field,
                                                                direction
                                                            }) => {
    const [reason, setReason] = useState('');
    const [reportingManagerId, setReportingManagerId] = useState('');
    const [expanded, setExpanded] = useState(false);
    const [balanceData, setBalanceData] = useState<ILeaveBalanceData | null>({
        employeeName: '',
        leaveType: '',
        applied: 0,
        balance: 0,
        alotted: 0
    });

    useEffect(() => {
        if (!data) return;
        setBalanceData(null);
        setReason('');

        if (data.employeeId && data.leavePeriodId) {
            console.log(data, 'data')
            fetchLeaveBalance();
        }
        if (isAdmin && data.employeeId) {
            fetchReporitngManagerId();
        }
    }, []);

    async function fetchReporitngManagerId() {
        const response = await server.employee.employeeDetailsByID(data.employeeId, {
            "include-family-details": true,
            "include-experiences": true,
            "include-bank-detail": true
        });
        setReportingManagerId(response.reportingManagerId);
    }

    async function updateRequestStatus(status: string, id: string) {
        try {
            if (status === 'APPROVED') {
                await server.leave.request.approve(id);
            }
            if (status === 'REJECTED') {
                let reas = reason ? reason : 'not-approved';
                await server.leave.request.reject(id, reas);
            }
        } catch (e) {
            console.log(e)
        } finally {
            fetchLeaveRequests(pageNumber, field, direction);
            handleClose();
        }
    }

    async function fetchLeaveBalance() {
        try {
            const payload = {
                employeeId: data.employeeId,
                leavePeriodId: data.leavePeriodId,
                leaveType: data.leaveType
            }
            const response = await server.leave.balance.getById(payload);
            const empRes = response[0]
            const selectedLeave = empRes.leaves.find(
                (leave: any) => leave.type === data.leaveType
            );
            setBalanceData({
                employeeName: getName(
                    empRes.employeeName.firstName,
                    empRes.employeeName.middleName || '',
                    empRes.employeeName.lastName
                ),
                leaveType: Leave_Type[selectedLeave.type as keyof typeof Leave_Type],
                applied: selectedLeave.applied,
                balance: selectedLeave.balance,
                alotted: selectedLeave.unit
            });
        } catch (error) {
            console.error('Error fetching leave balance:', error);
        }
    }

    async function handleActionClick(status: string) {
        await updateRequestStatus(status, data.id);
    }

    function validateLeaveActions(record: any) {
        let isRejectedValid = false, isApproveValid = false;
        const role = isAdmin ? 'admin' : supervisor.isSupervisor ? 'supervisor' : '';
        console.log(role, 'role ');
        const leaveDate = dayjs(record.date);
        const today = dayjs();
        const adminActionValidation = role === 'admin';
        const supervisorActionValidation = (role === 'supervisor' &&
            (leaveDate.isSame(today, 'date') || leaveDate.isAfter(today, 'date')));
        if (adminActionValidation || supervisorActionValidation) {
            if (record.state === 'PENDING') {
                isApproveValid = true;
                isRejectedValid = true;
            }
            if (record.state === 'APPROVED') {
                isRejectedValid = true;
            }
            if (record.state === 'REJECTED') {
                isApproveValid = true;
            }
        }
        return {isRejectedValid, isApproveValid};
    }

    const getLeaveActions = () => {
        const {isRejectedValid, isApproveValid} = validateLeaveActions(data);
        return (
            <div className={'action-wrapper'}>
                <Button className={'action-btn cancel'} onClick={handleModalClose}>
                    Cancel
                </Button>
                <Button className={`action-btn approve ${!isApproveValid ? 'action-disabled' : ''}`}
                        onClick={() => handleActionClick('APPROVED')}
                        disabled={!isApproveValid}
                >Approve</Button>
                <Button className={`action-btn  reject ${!isRejectedValid ? 'action-disabled' : ''}`}
                        disabled={!isRejectedValid}
                        onClick={() => handleActionClick('REJECTED')}
                >Reject
                </Button>
            </div>
        )
    }

    function handleClose() {
        setBalanceData(null);
        setReason('');
        handleModalClose();
    }

    const getStatusClass = (state: string) => {
        switch (state) {
            case 'APPROVED':
                return 'status-approved';
            case 'REJECTED':
                return 'status-rejected';
            case 'PENDING':
                return 'status-pending';
            case 'CANCELLED':
                return 'status-cancelled'
            default:
                return '';
        }
    };

    const date = data.date ? dayjs(data.date).format(Locale.displayDate) : "-";

    return (
        <Modal
            title="Leave Request Review"
            open={isOpen}
            onCancel={handleClose}
            className="hrms-app leave-review-modal"
            footer={getLeaveActions}
        >
            <div className="leave-review-container">

                <div className={"employee-detail-section"}>

                    <p className={'employee-name'}>
                        <div className="employee-name-wrapper">
                            <EmployeeAvatar
                                name={{
                                    firstName: data?.employeeName?.firstName,
                                    lastName: data?.employeeName?.lastName
                                }}
                                thumbnailId={data?.profilePhotoThumbnailId}
                                size={40}
                            />
                            {balanceData?.employeeName}
                        </div>
                    </p>
                    <p className={`employee-leave-status ${getStatusClass(data.state)}`}>
                        {data.state}
                    </p>
                </div>

                <div className={'leave-details-section'}>
                    <div className={'leave-details-item'}>
                        <div className={'leave-details-icon-text-wrapper'}>
                            <CalendarOutlined className={'leave-details-item__icon calendar-icon'}/>
                            <span className={'leave-details-item__text'}>Applied For </span>
                        </div>

                        <div className={'leave-details-item__value'}>
                            {date}
                        </div>
                    </div>

                    <div className={'leave-details-item'}>
                        <div className={'leave-details-icon-text-wrapper'}>
                            <ClockCircleOutlined className={'leave-details-item__icon clock-icon'}/>
                            <span className={'leave-details-item__text'}>Session </span>
                        </div>

                        <div className={'leave-details-item__value'}>
                            {removeUnderScoreWithLowerCase(data.session)}
                        </div>
                    </div>

                    <div className={'leave-details-item'}>
                        <div className={'leave-details-icon-text-wrapper'}>
                            <ScheduleOutlined className={'leave-details-item__icon leave-type-icon'}/>
                            <span className={'leave-details-item__text'}>Leave Type </span>
                        </div>

                        <div className={'leave-details-item__value'}>
                            {balanceData?.leaveType}
                        </div>
                    </div>
                </div>

                <div className={'leave-details-item reason-section'}>
                    <div className={'leave-details-icon-text-wrapper'}>
                        <MessageOutlined className={'leave-details-item__icon message-icon'}/>
                        <span className={'leave-details-item__text'}>Reason </span>
                    </div>
                    <div className={'leave-details-item__value'}>
                        <div className={'leave-details-item__value reason-text-wrapper'}>
                                    <span
                                        className={`leave-review-container data ${expanded ? 'reason-expanded' : 'reason-collapsed'}`}>{data.reason}</span>
                            {data.reason && data.reason.length > 50 && (
                                <span
                                    className="show-more"
                                    onClick={() => setExpanded(!expanded)}
                                >
                                          {expanded ? 'Show less' : 'Show more'}
                                        </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="leave-balance-details-section">
                    <h4 className={'leave-balance-details-section__heading'}>
                        Leave Balance Details
                    </h4>

                    <div className={'leave-balance-details-item-wrapper'}>
                        <div className="leave-balance-details-item">
                            <span className={'leave-balance-details-item__label'}>Total Allotted</span>
                            <span className={'leave-balance-details-item__value'}>{balanceData?.alotted}</span>
                        </div>

                        <div className="leave-balance-details-item">
                            <span className={'leave-balance-details-item__label'}> Applied</span>
                            <span className={'leave-balance-details-item__value'}>{balanceData?.applied}</span>
                        </div>

                        <div className="leave-balance-details-item">
                            <span className={'leave-balance-details-item__label'}>Remaining  </span>
                            <span className={'leave-balance-details-item__value'}>{balanceData?.balance}</span>
                        </div>
                    </div>
                </div>

                <div className={'rejection-message-box'}>
                    <span className={'rejection-message-box__title'}>Rejection Reason</span>
                    <div className={'rejection-message-box__content-box'}>
                        <TextArea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="please mention reason in case of leave rejection"
                        />
                    </div>
                </div>

            </div>
        </Modal>
    );
};

export default LeaveReviewModal;